<template>
  <div class="select">
     <v-select
        :label="'startDate'"
        :options="forecastPeriods"
        v-model="selectedValue"
        class="w-full">
        <template slot="selected-option"  slot-scope="{ startDate, endDate }">
             {{ startDate | toDate }} - {{ endDate | toDate }}
          </template>
          <template slot="option" slot-scope="{ startDate, endDate }">
            {{ startDate | toDate }} - {{ endDate | toDate }}
          </template>
     </v-select>
  </div>
</template>

<script>
import vSelect from 'vue-select';

export default {
  name: 'ForecastSelection',
  components: {
    vSelect
  },
  props: {
    value: {
      default: null,
      type: Object
    }
  },
  data() {
    return {
      selectedValue: this.value
    };
  },
  watch: {
    selectedValue(val) {
      this.$emit("valueChanged", val);
    }
  },
  computed : {
    forecastPeriods() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.$store.state.gradeControl.forecastPeriodList.sort((a, b) => { return (new Date(a.startDate) < new Date(b.endDate)) ? 1 : -1 });
    }
  },
  mounted() {
    const selectedProject = Number(this.$store.state.projectId);
    this.$store.dispatch("gradeControl/fetchLocationForecastPeriods", selectedProject).then(() => {
     
      const today = new Date();
      const todayPeriod = this.$store.state.gradeControl.forecastPeriodList.find(p => new Date(p.startDate) <= today && new Date(p.endDate) >= today);
      
      if (!todayPeriod) {
        this.selectedValue = todayPeriod;
      } else {
        this.selectedValue = this.$store.state.gradeControl.forecastPeriodList[0];
      }
    });
  } 
}
</script>
<style lang="scss">
.select {
    min-width: 225px;
}
</style>